module.exports = __webpack_public_path__ + "static/campaignzero-f87d8da2a2fb98db9da4bce14af4160e.png";